import IconDownload from './icon-download';

export default IconDownload;
export { IconDownload };
